import React, { useState } from "react";
import { useEffect } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';

export default function Dailyloanlist(){

    const[dlist,setDlist] = useState([]);
    const[date, setDate] = useState(new Date().toISOString().slice(0,10));
    const[enddate,setEnddate]= useState(new Date().toISOString().slice(0,10));
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [userid,setUserid] =useState( parseInt(localStorage.getItem("userid")));
    const usertype = parseInt(localStorage.getItem("utype"));
    const [checked, setChecked] = useState(false);
    var i = 0;
    
 useEffect(()=> {
 if(usertype === 1) 
 {

    if(checked === false)
    {
    fetch(API_URL+"api/Loan/GetLoanList?sdate="+ date +"&ldate="+enddate )
    .then(response => response.json())
    .then(data => {setDlist(data)}) 
    }
    else
    {
        fetch(API_URL+"api/Loan/GetLoanByUser?sdate="+date+"&edate="+enddate+"&userid="+userid)
        .then(response => response.json())
        .then(data => {setDlist(data)})
    }
}
    
else
{
    
    fetch(API_URL+"api/Loan/GetLoanByUser?sdate="+date+"&edate="+date+"&userid="+userid)
        .then(response => response.json())
        .then(data => {setDlist(data)})
}
},[date,enddate,userid,checked])   

    {/* function getloanreport()
    {
        fetch(API_URL+"api/Loan/GetLoanList?sdate="+document.getElementById("sdate").value+"&ldate="+document.getElementById("ldate").value)
        .then(response => response.json())
        .then(data => {setDlist(data)})
    */}

    console.log(dlist);
    
    const Total = dlist.length > 0 ? dlist.reduce((tot,el)=>tot+ el.LoanAmount,0): 0;
    console.log(Total);
    return(
        <>
        <div className="reportheader"> 
            Loan Distripution
            <Navbar/>
    </div>      

       <div style={{backgroundColor:"lightskyblue",padding:"10px"}}>
       {usertype !== 1 ? <> 
       <label for="sdate" style={{marginTop:"10px"}}>Start Date</label>
        <input id="sdate" type="date" defaultValue={date} style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"15px"}} onChange={(e)=>{setDate(e.target.value)}} ></input><br/></>
         :
         <>
        <label for="sdate" style={{marginTop:"10px"}}>Start Date</label>
        <input id="sdate" type="date" defaultValue={date} style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"15px"}} onChange={(e)=>{setDate(e.target.value)}} ></input><br/>
       
        <label for="ldate" style={{marginTop:"10px"}}>End Date</label>
        <input id="ldate" type="date" defaultValue={enddate} style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"20px"}}onChange={(e)=>{setEnddate(e.target.value)}} ></input><br/></>}
        {usertype === 1 ? <>
        <label><input type="checkbox" id='byuser' style={{height:"18px",width:"18px"}} onChange={(e)=>{setChecked(!checked); checked ? document.getElementById('userid').disabled = true : document.getElementById('userid').disabled = false}}/>By</label><br/>
        <label for="userid" style={{marginTop:"10px",marginLeft:"8px"}}>UserID</label>

        <input id="userid" style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"27px"}} onChange={(e)=>{setUserid(e.target.value)}} disabled></input></> : <></>}
        
        </div> 
        <table style={{width:"100%",marginTop:"20px",backgroundColor:"lightskyblue",marginBottom:"40px"}}>
            <tr>
                <th>S.No</th>
                <th>Loan No</th>
                <th>Customer Name</th>
                <th>Amount</th>
            </tr>
        {dlist.length > 0 ? <>
        {dlist.map(loan =>{return(<tr>
            <td>{++i}</td>
            <td style={{textAlign:"center"}}>{loan.AccountNo}</td>
            <td style={{textAlign:"left"}}>{loan.CustomerName}</td>
            <td>{loan.LoanAmount}</td>
        </tr>)})}
        <tr>
            <td></td>
            <td></td>
            <td style ={{fontWeight:"bolder"}}> Total</td>
            <td style ={{fontWeight:"bolder"}}>{Total}</td>
        </tr></> : <></>}
        </table>
        <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}}>Back</button>
        </>
    )        
        
        
}